import { render, staticRenderFns } from "./BatchAttesterDashboard.vue?vue&type=template&id=10e57b23&scoped=true&"
import script from "./BatchAttesterDashboard.vue?vue&type=script&lang=js&"
export * from "./BatchAttesterDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e57b23",
  null
  
)

export default component.exports